(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireda16"];
var parcelRegister = parcelRequire.register;
parcelRegister("4jlPh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "make", function () { return $3239ddfd94877bb3$export$dd44f18ab656f3bb; });
$parcel$export(module.exports, "$$default", function () { return $3239ddfd94877bb3$export$aa541d093b11ace2; });
$parcel$export(module.exports, "default", function () { return $3239ddfd94877bb3$export$aa541d093b11ace2; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $3sSBX = parcelRequire("3sSBX");

var $gFKzh = parcelRequire("gFKzh");

var $ePRCc = parcelRequire("ePRCc");

var $efwy1 = parcelRequire("efwy1");

var $hBcYV = parcelRequire("hBcYV");

var $37BLX = parcelRequire("37BLX");

var $lBn5n = parcelRequire("lBn5n");

var $gSZul = parcelRequire("gSZul");

var $dhngN = parcelRequire("dhngN");

var $8E2YL = parcelRequire("8E2YL");
function $3239ddfd94877bb3$var$LauncherApp(Props) {
    var configId = Props.configId;
    var onOpenLink = Props.onOpenLink;
    var attributes = Props.attributes;
    var embedType = Props.embedType;
    var className = Props.className;
    var match = $efwy1.use(undefined);
    var namespace = match.namespace;
    $hBcYV.useRouter(undefined);
    var match$1 = $8E2YL.use(undefined);
    var trackEvent = $gFKzh.use(embedType);
    var contextualRoot = $lBn5n.useContextualRoot(/* Open */ 2, embedType, window.location.pathname);
    var contextualL1s = $lBn5n.useContextualL1s(embedType, /* Open */ 2, window.location.pathname);
    var pageOnlyHasLauncher = $37BLX.countInlineElementsByNamespace(namespace) === 0 && $37BLX.countBottombarElementsByNamespace(namespace) === 0;
    var tmp = {
        config: match$1.config,
        embedType: embedType,
        children: /*#__PURE__*/ $g85JO.createElement($3sSBX.make, {
            categories: $i7mYY.keep(contextualL1s, function(category) {
                return category.visibleInMenuBar;
            }),
            centered: true,
            className: $1TRFX.make([
                $ezf3v.prefix("bg-main text-secondary"),
                $2whNH.getWithDefault(className, $ezf3v.prefix("py-4"))
            ]),
            onTrackClick: function onTrackClick(param) {
                $iv6Yc.app(trackEvent, [
                    "open",
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined
                ]);
            },
            theme: /* Main */ 0
        })
    };
    if (attributes !== undefined) tmp.attributes = $loT9g.valFromOption(attributes);
    if (contextualRoot !== undefined) tmp.contextualRoot = $loT9g.valFromOption(contextualRoot);
    var tmp$1;
    if (pageOnlyHasLauncher) {
        var tmp$2 = {
            configId: configId,
            embedType: embedType,
            enabled: false
        };
        if (onOpenLink !== undefined) tmp$2.onOpenLink = $loT9g.valFromOption(onOpenLink);
        if (attributes !== undefined) tmp$2.attributes = $loT9g.valFromOption(attributes);
        tmp$1 = /*#__PURE__*/ $g85JO.createElement($gSZul.make, tmp$2);
    } else tmp$1 = null;
    return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement($ePRCc.make, {
        initiator: "launcher",
        portal: false,
        children: /*#__PURE__*/ $g85JO.createElement($dhngN.make, tmp)
    }), tmp$1);
}
$3239ddfd94877bb3$var$LauncherApp.displayName = "LauncherApp";
var $3239ddfd94877bb3$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($3239ddfd94877bb3$var$LauncherApp);
var $3239ddfd94877bb3$export$aa541d093b11ace2 = $3239ddfd94877bb3$export$dd44f18ab656f3bb;
 /* make Not a pure module */ 
});
parcelRegister("3sSBX", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $285e594aca7fdb2f$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $1xf0g = parcelRequire("1xf0g");

var $dzlIC = parcelRequire("dzlIC");

var $5tfgg = parcelRequire("5tfgg");

var $hBcYV = parcelRequire("hBcYV");

var $eIwLU = parcelRequire("eIwLU");

var $9pMGg = parcelRequire("9pMGg");

var $8E2YL = parcelRequire("8E2YL");

var $b8WNX = parcelRequire("b8WNX");
function $285e594aca7fdb2f$var$Launcher(Props) {
    var style = Props.style;
    var isNestedOpt = Props.isNested;
    var highlightedCategoryId = Props.highlightedCategoryId;
    var categories = Props.categories;
    var forceStyle = Props.forceStyle;
    var centeredOpt = Props.centered;
    var paddedOpt = Props.padded;
    var classNameOpt = Props.className;
    var dataTestId = Props.dataTestId;
    var sliderDataTestId = Props.sliderDataTestId;
    var sliderInsetMargin = Props.sliderInsetMargin;
    var slidesPerView = Props.slidesPerView;
    var onItemMouseEnter = Props.onItemMouseEnter;
    var onItemClick = Props.onItemClick;
    var onTrackClick = Props.onTrackClick;
    var onItemRendered = Props.onItemRendered;
    var ariaLabel = Props.ariaLabel;
    var tabIndex = Props.tabIndex;
    var theme = Props.theme;
    var isNested = isNestedOpt !== undefined ? isNestedOpt : false;
    var centered = centeredOpt !== undefined ? centeredOpt : false;
    var padded = paddedOpt !== undefined ? paddedOpt : true;
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var match = $hBcYV.useRouter(undefined);
    var listPageType = match.listPageType;
    var goTo = match.goTo;
    var match$1 = $9pMGg.use(undefined);
    var onClick = match$1.onLauncherItemClick;
    var activeCategory = $hBcYV.useActiveCategory(undefined, undefined, categories);
    var match$2 = $8E2YL.use(undefined).config;
    var settings = match$2.settings;
    $g85JO.useEffect(function() {
        var isAnyQuickViewStories = $i7mYY.some(categories, $1xf0g.isQuickViewStoriesEnabled);
        if (isAnyQuickViewStories && !isNested) $iv6Yc._1($b8WNX.preload, undefined);
    }, [
        categories
    ]);
    var match$3 = settings.mkrBio;
    var border = match$3 !== undefined && !isNested ? /* BorderBottom */ 1 : /* BorderNone */ 0;
    var match$4 = settings.mkrBio;
    var indicatorThickness = match$4 !== undefined ? /* Sm */ 1 : /* Normal */ 0;
    var match$5 = settings.mkrBio;
    var height = match$5 !== undefined ? /* Lg */ 1 : /* Normal */ 0;
    var activeCategoryPath = $i7mYY.map($2whNH.mapWithDefault($2whNH.map(activeCategory, function(category) {
        return category.id;
    }), [], function(id) {
        return $1xf0g.getCategoryPathById(categories, id);
    }), function(category) {
        return category.id;
    });
    var activeCategoryId = $2whNH.map($i7mYY.getBy(categories, function(category) {
        return activeCategoryPath.includes(category.id);
    }), function(category) {
        return category.id;
    });
    var match$6 = settings.indexNode;
    var activeCategoryId$1 = activeCategoryId !== undefined ? activeCategoryId : match$6 !== undefined && match$6.visibleInMenuBar && match.route !== /* NotRendered */ 0 && !isNested ? match$6.id : undefined;
    var activeCategoryId$2 = $2whNH.keep(activeCategoryId$1, function(param) {
        if ($7bjme.notequal(listPageType, /* History */ 1)) return $7bjme.notequal(listPageType, /* Favorites */ 0);
        else return false;
    });
    var layout = forceStyle !== undefined ? forceStyle : isNested ? settings.nestedCategoryLayout : settings.categoryLayout;
    var size = isNested ? settings.nestedCategorySize : settings.categorySize;
    var onClick$1 = $g85JO.useCallback($iv6Yc.__1(onClick), [
        onClick
    ]);
    var onClick$2 = $2whNH.getWithDefault(onItemClick, onClick$1);
    var onMouseEnter = $2whNH.getWithDefault(onItemMouseEnter, function(param) {});
    var partial_arg = false;
    var items = $i7mYY.map(categories, function(param) {
        return $5tfgg.fromCategory(partial_arg, param);
    });
    var match$7 = settings.mkrBio;
    var match$8 = items.length;
    var items$1 = match$7 !== undefined && match$8 === 1 ? [] : items;
    var onChange = function onChange(id) {
        var category = $i7mYY.getBy(categories, function(category) {
            return category.id === id;
        });
        if (category === undefined) return;
        $2whNH.forEach(onTrackClick, function(onTrackClick) {
            $iv6Yc._1(onTrackClick, category);
        });
        var match = $1xf0g.Link.getCardLink(category);
        if (match === undefined) return $iv6Yc._1(onClick$2, category);
        switch(match.TAG | 0){
            case /* URL */ 0:
                return;
            case /* Category */ 1:
                var match$1 = match._0;
                return $iv6Yc._3(goTo, undefined, undefined, {
                    TAG: /* ListPage */ 1,
                    _0: {
                        listPageType: {
                            TAG: /* Category */ 0,
                            _0: match$1.categoryId
                        },
                        viewPLP: false,
                        filters: match$1.filters,
                        sort: undefined
                    }
                });
            case /* Product */ 2:
                var match$2 = match._0;
                return $iv6Yc._3(goTo, undefined, undefined, {
                    TAG: /* PDP */ 2,
                    _0: {
                        categoryId: undefined,
                        productCategoryId: match$2.productCategoryId,
                        productId: match$2.productId,
                        variantId: match$2.variantId,
                        zoomedPhotoIndex: undefined
                    }
                });
            case /* StoreCategory */ 3:
                var match$3 = match._0;
                return $iv6Yc._3(goTo, undefined, undefined, {
                    TAG: /* ListPage */ 1,
                    _0: {
                        listPageType: {
                            TAG: /* StoreCategory */ 2,
                            _0: {
                                categoryId: match$3.categoryId,
                                sourceNodeId: category.id
                            }
                        },
                        viewPLP: false,
                        filters: undefined,
                        sort: match$3.sortBy
                    }
                });
            case /* CustomAction */ 4:
                var match$4 = match._0;
                $dzlIC.triggerCustomFunctionWithoutProducts(match$4.code, match$4.name, undefined, undefined);
                return;
        }
    };
    var onHover = function onHover(id) {
        var category = $i7mYY.getBy(categories, function(category) {
            return category.id === id;
        });
        if (category !== undefined) return $iv6Yc._1(onMouseEnter, category);
    };
    if ($7bjme.equal(items$1, [])) return null;
    var tmp = {
        items: items$1,
        layout: layout,
        size: size,
        theme: theme,
        centered: centered,
        verticallyCenter: layout === /* Labels */ 0,
        className: className,
        onChange: onChange,
        onHover: onHover,
        border: border,
        indicatorThickness: indicatorThickness,
        height: height
    };
    if (highlightedCategoryId !== undefined) tmp.highlightValue = $loT9g.valFromOption(highlightedCategoryId);
    if (activeCategoryId$2 !== undefined) tmp.activeValue = $loT9g.valFromOption(activeCategoryId$2);
    if (dataTestId !== undefined) tmp.dataTestId = $loT9g.valFromOption(dataTestId);
    if (sliderDataTestId !== undefined) tmp.sliderDataTestId = $loT9g.valFromOption(sliderDataTestId);
    if (style !== undefined) tmp.style = $loT9g.valFromOption(style);
    var tmp$1 = padded ? undefined : 0;
    if (tmp$1 !== undefined) tmp.padding = tmp$1;
    if (onItemRendered !== undefined) tmp.onItemRendered = $loT9g.valFromOption(onItemRendered);
    var tmp$2 = padded ? undefined : /* Zero */ 3;
    if (tmp$2 !== undefined) tmp.gap = $loT9g.valFromOption(tmp$2);
    if (slidesPerView !== undefined) tmp.slidesPerView = slidesPerView;
    if (sliderInsetMargin !== undefined) tmp.sliderInsetMargin = $loT9g.valFromOption(sliderInsetMargin);
    if (ariaLabel !== undefined) tmp.ariaLabel = $loT9g.valFromOption(ariaLabel);
    if (tabIndex !== undefined) tmp.tabIndex = $loT9g.valFromOption(tabIndex);
    return /*#__PURE__*/ $g85JO.createElement($eIwLU.make, tmp);
}
$285e594aca7fdb2f$var$Launcher.displayName = "Launcher";
var $285e594aca7fdb2f$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($285e594aca7fdb2f$var$Launcher);
var $285e594aca7fdb2f$export$aa541d093b11ace2 = $285e594aca7fdb2f$export$dd44f18ab656f3bb;
 /* make Not a pure module */ 
});
parcelRegister("b8WNX", function(module, exports) {

$parcel$export(module.exports, "preload", function () { return $81ce0e7d77235b59$export$513ccb98c53b8039; });
$parcel$export(module.exports, "make", function () { return $81ce0e7d77235b59$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $81ce0e7d77235b59$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("hwhk1"));
});
function $81ce0e7d77235b59$var$QuickViewOverlay_Lazy(Props) {
    return /*#__PURE__*/ $g85JO.createElement($81ce0e7d77235b59$var$component, Props);
}
$81ce0e7d77235b59$var$QuickViewOverlay_Lazy.displayName = "QuickViewOverlay_Lazy";
var $81ce0e7d77235b59$export$513ccb98c53b8039 = $81ce0e7d77235b59$var$component.preload;
var $81ce0e7d77235b59$export$dd44f18ab656f3bb = $81ce0e7d77235b59$var$QuickViewOverlay_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("hwhk1", function(module, exports) {












module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("67jxL")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("lvXsZ")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6zo4Z")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("fsMVk")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("519fX")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("3pqCl"))
]).then(function() {
    return parcelRequire("1xMeg");
});

});



parcelRegister("37BLX", function(module, exports) {

$parcel$export(module.exports, "countInlineElementsByNamespace", function () { return $245f535c80fa97b7$export$7460c80d7c5cf75c; });
$parcel$export(module.exports, "countBottombarElementsByNamespace", function () { return $245f535c80fa97b7$export$3a44f3abf1840775; });
$parcel$export(module.exports, "countLauncherElementsByNamespace", function () { return $245f535c80fa97b7$export$ac754b9504a93a08; });
$parcel$export(module.exports, "countSectionElementsByNamespace", function () { return $245f535c80fa97b7$export$b75c7a415a35e365; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $d3YYW = parcelRequire("d3YYW");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $h6rW7 = parcelRequire("h6rW7");
function $245f535c80fa97b7$export$36d3479b5d03ac38(el) {
    var namespace = el.getAttribute("data-namespace");
    if (namespace == null) return $h6rW7.empty;
    else return $h6rW7.fromString(namespace);
}
function $245f535c80fa97b7$export$d0ebfc305a7a6844(elements, namespace) {
    var namespace$1 = $2whNH.getWithDefault(namespace, $h6rW7.empty);
    return $i7mYY.keep($2whNH.getWithDefault($2whNH.map(elements, $d3YYW.values), []), function(element) {
        return $7bjme.equal($245f535c80fa97b7$export$36d3479b5d03ac38(element), namespace$1);
    });
}
function $245f535c80fa97b7$export$a82d8d7911f406ff(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsInline, namespace);
}
function $245f535c80fa97b7$export$310f9fbcf0732046(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElements, namespace);
}
function $245f535c80fa97b7$export$677c1fd84b0cad4f(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsLauncher, namespace);
}
function $245f535c80fa97b7$export$bbd7846266bc9fe8(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsSection, namespace);
}
function $245f535c80fa97b7$export$58368f7b4fc9b76d(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsPDP, namespace);
}
function $245f535c80fa97b7$export$7460c80d7c5cf75c(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsInline, namespace).length;
}
function $245f535c80fa97b7$export$3a44f3abf1840775(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElements, namespace).length;
}
function $245f535c80fa97b7$export$ac754b9504a93a08(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsLauncher, namespace).length;
}
function $245f535c80fa97b7$export$b75c7a415a35e365(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsSection, namespace).length;
}
function $245f535c80fa97b7$export$65ea36736e2b48c7(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsPDP, namespace).length;
}
 /* No side effect */ 
});

parcelRegister("lBn5n", function(module, exports) {

$parcel$export(module.exports, "useContextualRoot", function () { return $fb9ef608eb76e9b2$export$fd42e504a4d8f825; });
$parcel$export(module.exports, "useContextualL1s", function () { return $fb9ef608eb76e9b2$export$f20aa461418ac738; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $1xf0g = parcelRequire("1xf0g");

var $bygWp = parcelRequire("bygWp");

var $hBcYV = parcelRequire("hBcYV");

var $8E2YL = parcelRequire("8E2YL");
function $fb9ef608eb76e9b2$export$b829272b1dcc6798(url) {
    try {
        return $2whNH.map($2whNH.map($bygWp.maybeMakeUrl(url), function(prim) {
            return prim.pathname;
        }), function(prim) {
            return prim.toLowerCase();
        });
    } catch (exn) {
        return;
    }
}
function $fb9ef608eb76e9b2$export$1e0981608463ce2(urlPathname, topLevelCategories) {
    if (urlPathname === "/") return;
    var l1Match = topLevelCategories.find(function(cat) {
        if (!(!$1xf0g.isQuickView(cat) && !$1xf0g.isLinkCategory(cat) && !$1xf0g.hasMedialessCard(cat))) return false;
        var link = $1xf0g.getCategoryLink(cat);
        if (link !== undefined) return $7bjme.equal(urlPathname.toLowerCase(), $fb9ef608eb76e9b2$export$b829272b1dcc6798(link));
        else return false;
    });
    var l1Match$1 = l1Match === undefined ? undefined : $loT9g.some(l1Match);
    var l2OrDeeperMatch = $1xf0g.findCategoryBy(topLevelCategories, function(cat) {
        if (!(!$1xf0g.isQuickView(cat) && !$1xf0g.isLinkCategory(cat) && !$1xf0g.hasMedialessCard(cat))) return false;
        var match = $1xf0g.getCategoryLink(cat);
        if (l1Match !== undefined) {
            if (match !== undefined && $7bjme.equal(urlPathname.toLowerCase(), $fb9ef608eb76e9b2$export$b829272b1dcc6798(match))) return l1Match.id !== cat.id;
            else return false;
        } else if (match !== undefined) return $7bjme.equal(urlPathname.toLowerCase(), $fb9ef608eb76e9b2$export$b829272b1dcc6798(match));
        else return false;
    });
    if (l2OrDeeperMatch !== undefined) return l2OrDeeperMatch;
    else return l1Match$1;
}
function $fb9ef608eb76e9b2$export$7f3d9773c89e0196(topLevelCategories, category) {
    return $1xf0g.getCategoryParentById(topLevelCategories, category.id);
}
function $fb9ef608eb76e9b2$export$2b5083f21a7660c3(categories, fallback) {
    if ($i7mYY.keep(categories, function(category) {
        return category.visibleInMenuBar;
    }).length === 0) return fallback;
    else return categories;
}
function $fb9ef608eb76e9b2$export$fd42e504a4d8f825(drawerState, embedType, urlPathname) {
    var match = $8E2YL.use(undefined).config;
    var settings = match.settings;
    var canUseContextualL1s = embedType !== /* Inline */ 1 && settings.contextualL1s && drawerState !== /* Open */ 2 || settings.contextualInline && embedType === /* Inline */ 1;
    if (canUseContextualL1s) return $fb9ef608eb76e9b2$export$1e0981608463ce2(urlPathname, match.categories);
}
function $fb9ef608eb76e9b2$export$f20aa461418ac738(embedType, drawerState, urlPathname) {
    var hasNavigatedAwayFromContextualRoot = $g85JO.useRef(false);
    var match = $8E2YL.use(undefined).config;
    var topLevelCategories = match.categories;
    var activeCategory = $hBcYV.useActiveCategory(undefined, undefined, topLevelCategories);
    var canUseContextualL1s = (embedType === /* Bottombar */ 0 || embedType === /* Launcher */ 2) && match.settings.contextualL1s && drawerState !== /* Open */ 2;
    if (!canUseContextualL1s) return topLevelCategories;
    var contextualRoot = $fb9ef608eb76e9b2$export$1e0981608463ce2(urlPathname, topLevelCategories);
    var isInRootsOrParentPath;
    if (contextualRoot !== undefined) {
        var isRootPLP = $1xf0g.isPLP(contextualRoot);
        var inRootsPath = $2whNH.mapWithDefault(activeCategory, [], function(activeCat) {
            return $1xf0g.getCategoryPathById(topLevelCategories, activeCat.id);
        }).some(function(cat) {
            return cat.id === contextualRoot.id;
        });
        if (inRootsPath) isInRootsOrParentPath = true;
        else {
            var tmp = false;
            if (isRootPLP) {
                var rootParent = $1xf0g.getCategoryParentById(topLevelCategories, contextualRoot.id);
                tmp = $2whNH.mapWithDefault(activeCategory, [], function(activeCat) {
                    return $1xf0g.getCategoryPathById(topLevelCategories, activeCat.id);
                }).some(function(cat) {
                    return cat.id === $2whNH.mapWithDefault(rootParent, "", function(parent) {
                        return parent.id;
                    });
                });
            }
            isInRootsOrParentPath = tmp;
        }
    } else isInRootsOrParentPath = false;
    if (!isInRootsOrParentPath && drawerState === /* Open */ 2) hasNavigatedAwayFromContextualRoot.current = true;
    if (drawerState === /* Closed */ 0) hasNavigatedAwayFromContextualRoot.current = false;
    var canUseContextualL1s$1 = canUseContextualL1s && (drawerState === /* Closed */ 0 || isInRootsOrParentPath) && (drawerState === /* Closed */ 0 || !hasNavigatedAwayFromContextualRoot.current);
    if (contextualRoot === undefined) return topLevelCategories;
    if (!canUseContextualL1s$1) return topLevelCategories;
    var match$1 = contextualRoot.listPageActiveLayout;
    var isPLP;
    isPLP = typeof match$1 === "number" || match$1.TAG !== /* ProductGrid */ 3 ? false : true;
    if (isPLP) return $fb9ef608eb76e9b2$export$2b5083f21a7660c3($2whNH.mapWithDefault($1xf0g.getCategoryParentById(topLevelCategories, contextualRoot.id), topLevelCategories, $1xf0g.getChildren), topLevelCategories);
    else return $fb9ef608eb76e9b2$export$2b5083f21a7660c3($1xf0g.getChildren(contextualRoot), topLevelCategories);
}
 /* react Not a pure module */ 
});

parcelRegister("gSZul", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $c4b162cf14bff716$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $c4b162cf14bff716$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("hyJBF"));
});
function $c4b162cf14bff716$var$BottombarApp_Lazy(Props) {
    return /*#__PURE__*/ $g85JO.createElement($c4b162cf14bff716$var$component, Props);
}
$c4b162cf14bff716$var$BottombarApp_Lazy.displayName = "BottombarApp_Lazy";
var $c4b162cf14bff716$export$dd44f18ab656f3bb = $c4b162cf14bff716$var$BottombarApp_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("hyJBF", function(module, exports) {






















module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("95FGc")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("iw4cu")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("9INfO")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("lvXsZ")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6zo4Z")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("hywnS")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6BNlF")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("83oNX")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("aVOcH")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("hI3Yy")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("hBqlq"))
]).then(function() {
    return parcelRequire("hjWPk");
});

});



parcelRegister("hQWQG", function(module, exports) {

$parcel$export(module.exports, "ContentId", function () { return $cff4f11bdb1bf2d0$export$bb6896aa5755c251; });
$parcel$export(module.exports, "SectionId", function () { return $cff4f11bdb1bf2d0$export$9bbe9bfd3294dd44; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $ki9MN = parcelRequire("ki9MN");
var $cff4f11bdb1bf2d0$export$bb6896aa5755c251 = $ki9MN.Make({});
var $cff4f11bdb1bf2d0$export$9bbe9bfd3294dd44 = $ki9MN.Make({});
 /* ContentId Not a pure module */ 
});

parcelRegister("8wpG4", function(module, exports) {

$parcel$export(module.exports, "get", function () { return $63453ae6f4ab9cfc$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "set", function () { return $63453ae6f4ab9cfc$export$adaa4cf7ef1b65be; });
$parcel$export(module.exports, "$$delete", function () { return $63453ae6f4ab9cfc$export$e30d7c331cdcc0b5; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");
function $63453ae6f4ab9cfc$export$a47fb462a08de82f(key) {
    if (typeof key === "object") {
        var variant = key.NAME;
        if (variant === "optimizeVariant") return "mkr_variant__" + key.VAL + "";
        if (variant === "clientId") return "mkr_client_id__" + key.VAL + "";
    } else {
        if (key === "legacyClientId") return "mkr_client_id";
        if (key === "optimizePreviousEvents") return "mkr_experience_impression";
    }
    var tmp;
    if (typeof key === "object") {
        var variant$1 = key.NAME;
        tmp = variant$1 === "optimizeVariant" ? "optimizeVariant" : variant$1 === "scrollRestoration" ? "scroll-" + key.VAL : variant$1 === "history" ? "history" + $2whNH.mapWithDefault(key.VAL, "", function(id) {
            return "-" + id;
        }) : variant$1 === "clientId" ? "clientId" : variant$1 === "favorites" ? "favorites" + $2whNH.mapWithDefault(key.VAL, "", function(id) {
            return "-" + id;
        }) : variant$1 === "selectedMarket" ? "selectedMarket-" + key.VAL : "cart-" + key.VAL;
    } else tmp = key === "debuggerAllowed" ? "debuggerAllowed" : key === "navMenuConfig" ? "navMenuConfig" : key === "legacyClientId" ? "clientId" : key === "gridColumns" ? "gridColumns" : key === "optimizePreviousEvents" ? "optimizePreviousEvents" : "intro";
    return "smartnav__v" + String(2) + "__" + tmp;
}
function $63453ae6f4ab9cfc$export$3988ae62b71be9a3(_storage, key) {
    while(true){
        var storage = _storage;
        try {
            return $2whNH.flatMap($loT9g.null_to_opt($2whNH.getWithDefault(storage, localStorage).getItem($63453ae6f4ab9cfc$export$a47fb462a08de82f(key))), function(value) {
                if (value === "") return;
                else return value;
            });
        } catch (exn) {
            if (storage !== undefined) return;
            _storage = $loT9g.some(sessionStorage);
            continue;
        }
    }
}
function $63453ae6f4ab9cfc$export$adaa4cf7ef1b65be(_storage, key, value) {
    while(true){
        var storage = _storage;
        try {
            $2whNH.getWithDefault(storage, localStorage).setItem($63453ae6f4ab9cfc$export$a47fb462a08de82f(key), value);
            return;
        } catch (exn) {
            if (storage !== undefined) return;
            _storage = $loT9g.some(sessionStorage);
            continue;
        }
    }
}
function $63453ae6f4ab9cfc$export$e30d7c331cdcc0b5(_storage, key) {
    while(true){
        var storage = _storage;
        try {
            $2whNH.getWithDefault(storage, localStorage).removeItem($63453ae6f4ab9cfc$export$a47fb462a08de82f(key));
            return;
        } catch (exn) {
            if (storage !== undefined) return;
            _storage = $loT9g.some(sessionStorage);
            continue;
        }
    }
}
var $63453ae6f4ab9cfc$export$83d89fbfd8236492 = 2;
 /* No side effect */ 
});

})();
//# sourceMappingURL=LauncherApp.bs.37bfcc34.js.map
